import React from 'react';
import { usePlanLimits } from '../hooks/usePlanLimits';

const TransactionFeeInfo = ({ catalogId, subscriptionPlan = 'FREE' }) => {
    const { platformFee, paystackFee, totalFee, vendorShare, loading } = usePlanLimits(catalogId);
    const isPaidPlan = subscriptionPlan !== 'FREE';

    if (loading) {
        return (
            <div className="mt-4 bg-white border border-gray-100 rounded-lg p-4 shadow-sm">
                <div className="animate-pulse">
                    <div className="h-4 bg-gray-200 rounded w-1/4 mb-3"></div>
                    <div className="h-20 bg-gray-200 rounded"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="mt-4 bg-white border border-gray-100 rounded-lg p-4 shadow-sm">
            <h4 className="font-medium text-gray-900 mb-3">Transaction Fees</h4>
            <div className="space-y-4">
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                    {/* Local Transactions */}
                    <div className="bg-gray-50 p-3 rounded-md">
                        <h5 className="text-sm font-medium text-gray-700">Local Transactions</h5>
                        <div className="mt-2 flex items-baseline">
                            <span className="text-lg font-semibold text-gray-900">
                                {totalFee}%
                            </span>
                            <span className="ml-1 text-sm text-gray-500">+ ₦100</span>
                        </div>
                        <p className="mt-2 text-xs text-gray-500 space-y-1">
                            <span className="block">• {paystackFee}% + ₦100: Payment processing</span>
                            {platformFee > 0 ? (
                                <span className="block">• {platformFee}%: Platform fee</span>
                            ) : (
                                <span className="block text-emerald-600 font-medium">
                                    • 0%: Platform fee (included in {subscriptionPlan.toLowerCase()} plan)
                                </span>
                            )}
                        </p>
                        <p className="mt-2 text-xs text-emerald-600 font-medium">
                            ₦100 fee waived for transactions under ₦2,500
                        </p>
                    </div>

                    {/* International Transactions - Only for Paid Plans */}
                    {/* {isPaidPlan ? (
                        <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                            <div className="flex items-center gap-2 mb-2">
                                <h5 className="text-sm font-medium text-gray-700">International Transactions</h5>
                                <span className="px-2 py-0.5 bg-blue-600 text-white text-xs rounded-full">
                                    {subscriptionPlan} Plan
                                </span>
                            </div>
                            <div className="mt-2 flex items-baseline">
                                <span className="text-lg font-semibold text-gray-900">
                                    3.9%
                                </span>
                                <span className="ml-1 text-sm text-gray-500">+ ₦100</span>
                            </div>
                            <p className="mt-2 text-xs text-gray-500 space-y-1">
                                <span className="block">• 3.9% + ₦100: International card processing</span>
                                {platformFee > 0 && (
                                    <span className="block">• {platformFee}%: Platform fee</span>
                                )}
                            </p>
                            <p className="mt-2 text-xs text-blue-600 font-medium">
                                Accept payments from customers worldwide
                            </p>
                        </div>
                    ) : (
                        <div className="bg-gray-50 p-3 rounded-md border border-gray-200 relative overflow-hidden">
                            <div className="absolute inset-0 bg-gray-900 bg-opacity-5 backdrop-blur-[2px] flex items-center justify-center z-10">
                                <div className="bg-white px-4 py-2 rounded-lg shadow-lg text-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mx-auto mb-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                    </svg>
                                    <p className="text-xs font-medium text-gray-700">Upgrade to accept</p>
                                    <p className="text-xs text-gray-500">international payments</p>
                                </div>
                            </div>
                            <h5 className="text-sm font-medium text-gray-400">International Transactions</h5>
                            <div className="mt-2 flex items-baseline">
                                <span className="text-lg font-semibold text-gray-400">3.9%</span>
                                <span className="ml-1 text-sm text-gray-400">+ ₦100</span>
                            </div>
                            <p className="mt-2 text-xs text-gray-400">
                                International card processing fees
                            </p>
                        </div>
                    )} */}
                </div>

                <div className="text-xs text-gray-500 pt-2 border-t border-gray-100">
                    <p className="mb-1">• Transfers to your bank account are processed automatically</p>
                    <p className="mb-1">• Settlement cycle: T+1 business day for transactions processed before 3 PM</p>
                    <p>• You receive approximately {vendorShare}% of transaction amount after fees</p>
                    {isPaidPlan && (
                        <p className="mt-1 text-blue-600">• International transactions settled in Naira at prevailing exchange rates</p>
                    )}
                </div>

                <div className="flex items-center gap-2 text-sm text-blue-600">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9z" clipRule="evenodd" />
                    </svg>
                    <a href="https://paystack.com/pricing" target="_blank" rel="noopener noreferrer" className="hover:underline">
                        More details about payment processing
                    </a>
                </div>
            </div>
        </div>
    );
};

export default TransactionFeeInfo;